import BaseDB from './db-base.js';
//
export class ViewState {
	constructor($log, $q) {
		'ngInject';
		this.$q = $q;
		this.LIMIT = 20;
		this.base = new BaseDB('mock-db', $log);
	}

	async getViewConfig(params) {
		const viewConfigExist = await this.base.db.view
			.where('name')
			.equals(params.name)
			.first()
			.catch(err => {
				throw err;
			});
		if (viewConfigExist) return viewConfigExist.config;
		this.base.$log.info('log viewConfigExist', viewConfigExist);
		const newConfig = await this.base.db.view
			.add({
				name: params.name,
				config: {limit: this.LIMIT},
				iat: Date.now().toString(),
			})
			.catch(err => {
				throw err;
			});
		if (newConfig.id) return {limit: this.LIMIT};
		else return {message: 'insert failed'};
	}

	async saveViewConfig(params) {
		const _record = await this.base.db.view
			.where({name: params.name})
			.first()
			.catch(err => {
				throw err;
			});
		if (!_record) return params;
		const {name, config} = params;
		const _params = {name, config, iat: Date.now().toString()};
		const updatedRecord = await this.base.db.view.update(_record.id, _params);
		if (updatedRecord === 1) return _params.config;
		else return {message: 'update failed'};
	}
}
//
let svcMod = angular.module('mod.svc.ViewStateSvc', []).service('ViewStateSvc', ViewState);
export default (svcMod = svcMod.name);
